"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSuccessNotification = void 0;
var Notification_1 = require("./Notification");
function useSuccessNotification(props) {
    var _a = Notification_1.useNotification(props), successNotification = _a.notification, setSuccessNotification = _a.setNotification;
    return { successNotification: successNotification, setSuccessNotification: setSuccessNotification };
}
exports.useSuccessNotification = useSuccessNotification;
//# sourceMappingURL=SuccessNotification.js.map